import styled from 'styled-components'

const MockLink = styled.a.attrs({
  href: '#'
})`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: #3089F3;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export default MockLink
